import React from "react";
import styles from "./GeoBlockScreen.module.scss";
import oneplayLogo from "../../assets/images/logos/oneplay-logo.svg";

const GeoBlockScreen: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src={oneplayLogo} alt="Oneplay" className={styles.logo} />
        <div className={styles.icon}>
          <i className="fas fa-map-marker-alt" aria-hidden />
        </div>
        <h1 className={styles.title}>Not Available in Your Region</h1>
        <p className={styles.message}>
          Oneplay Store is currently available in India only.
        </p>
      </div>
    </div>
  );
};

export default GeoBlockScreen;
